export const apiName: string = 'usuarios';
export const usuariosRoute: string = 'usuarios';
export const usuariosStorage: string = 'usuarios';
export const usuariosModuleName: any = {plural: 'Usuários', single: 'Usuário'};

export const usuariosQuery: any = {
  "where":{
    "ativo":true,
    "email":{"regexp":"/REPLACEHERE/i"}
  },
  "order":"email"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/usuarios/shared/data.service.ts
 **/